export default "__VITE_ASSET__ChCVZuIT__"